import { Col, Row } from "react-grid-system"
import { NormalFormTextArea, NormalFormTextField } from "../molecules"
import textsData from '@/textData/BillingFormTexts.json'
import { useUserLanguage } from "@/customHooks"
import { memo, useCallback, useRef } from "react"
import { AddressFormControlled } from "./AddressFormControlled"
import { AddressProps, BillingDataProps } from "@/custom-types"

type BillingFormControlledProps = {
  onChange: (billingData: BillingDataProps) => void;
  readOnly?: boolean;
  defaultData?: BillingDataProps;
}

const emptyData: BillingDataProps = {
  lastName: '',
  firstName: '',
  street: '',
  buildingNumber: '',
  addressLine: '',
  city: '',
  country: '',
  state: '',
  zipCode: '',
  wereGoing: '',
  bic: '',
  observation: '',
}

export const BillingFormControlled = memo(({onChange, readOnly, defaultData}: BillingFormControlledProps) => {
    const userLanguage = useUserLanguage()
    const texts = userLanguage === 'es' ? textsData.es : textsData.en
  
    const billingDataRef = useRef<BillingDataProps>(defaultData ?? emptyData)
  
    const handleFieldChange = useCallback((field: keyof BillingDataProps, value: string | null) => {
      billingDataRef.current = {
        ...billingDataRef.current,
        [field]: value ?? '',
      }
      onChange(billingDataRef.current)
    }, [onChange])

    const handleAddressChange = useCallback((address: AddressProps) => {
      billingDataRef.current = {
        ...billingDataRef.current,
        street: address.street,
        buildingNumber: address.buildingNumber,
        addressLine: address.addressLine,
        city: address.city,
        country: address.country,
        state: address.state,
        zipCode: address.zipCode
      }
      onChange(billingDataRef.current)
    }, [onChange])
  
    return (
      <>
        <Row>
          <Col md={6}>
            <NormalFormTextField
              label={texts.firstName}
              placeholder={texts.firstNamePlaceholder}
              name="billingFirstName"
              readOnly={readOnly}
              onChange={(value) => handleFieldChange('firstName', value)}
            />
          </Col>
          <Col md={6}>
            <NormalFormTextField
              label={texts.lastName}
              placeholder={texts.lastNamePlaceholder}
              name="billinglastName"
              readOnly={readOnly}
              onChange={(value) => handleFieldChange('lastName', value)}
            />
          </Col>
        </Row>
        <AddressFormControlled
          readOnly={readOnly}
          onChange={handleAddressChange}
          defaultAddress={{
            street: defaultData?.street || '',
            buildingNumber: defaultData?.buildingNumber || '',
            addressLine: defaultData?.addressLine || '',
            country: defaultData?.country || '',
            state: defaultData?.state || '',
            city: defaultData?.city || '',
            zipCode: defaultData?.zipCode || '',
          }}
        />
        {/* <Row>
          <Col md={3}>
            <NormalFormTextField
              label={texts.address.city}
              placeholder={texts.address.cityPlaceholder}
              name="billingCity"
  
            />
          </Col>
          <Col md={3}>
            <NormalFormTextField
              label={texts.address.state}
              placeholder={texts.address.statePlaceholder}
              name="billingState"
  
            />
          </Col>
          <Col md={3}>
            <NormalFormTextField
              label={texts.address.country}
              placeholder={texts.address.countryPlaceholder}
              name="billingCountry"
  
            />
          </Col>
          <Col md={3}>
            <NormalFormTextField
              label={texts.address.zipCode}
              placeholder={texts.address.zipCodePlaceholder}
              name="billingZipCode"
  
            />
          </Col>
        </Row> */}
        <Row>
          <Col md={6}>
            <NormalFormTextField
              label={texts.wereGoing}
              placeholder={texts.wereGoingPlaceholder}
              name="billingWereGoing"
              readOnly={readOnly}
              onChange={(value) => handleFieldChange('wereGoing', value)}
            />  
          </Col>
          <Col md={6}>
            <NormalFormTextField
              label={texts.bic.name}
              placeholder={texts.bic.namePlaceholder}
              name="billingBic"
              readOnly={readOnly}
              onChange={(value) => handleFieldChange('bic', value)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <NormalFormTextArea
              label={texts.observations}
              placeholder={texts.observationsPlaceholder}
              name="observations"
              readOnly={readOnly}
              onChange={(value) => handleFieldChange('observation', value)}
            />
          </Col>
        </Row>
      </>
    )
  }
)
